import { createAction } from 'redux-actions';
import { checkPropTypes } from 'prop-types';

function getPayloadCreator(propTypes = {}, type) {
  return function payloadCreator(payload = {}) {
    checkPropTypes(propTypes, payload, 'parameter', type);

    Object.keys(payload).forEach(key => {
      if (!propTypes[key]) {
        console.error(`Action ${type} has redundant property "${key}"`);
      }
    });
    return payload;
  };
}

export function createPrefixedActionFactory(prefix) {
  return function wrappedCreateActions({ type, propTypes }) {
    const actionType = `${prefix}_${type}`;
    const payloadCreator = getPayloadCreator(propTypes, actionType);
    return createAction(actionType, payloadCreator);
  };
}
